<template>
  <b-field label="Answer" :class="$style.container">
    <draggable v-model="dirtyOptions" @start="drag = true" @end="drag = false">
      <div
        class="columns"
        v-for="(option, i) in [...dirtyOptions, '']"
        :key="i"
      >
        <div class="column">
          <b-field>
            <div :class="$style.inputContainer">
              <div :class="$style.dotContainer">
                <div :class="$style.dot" />
              </div>
              <div class="control is-clearfix">
                <input
                  type="text"
                  class="input"
                  v-model="dirtyOptions[i]"
                  :placeholder="
                    i === dirtyOptions.length ? 'Add another ...' : ''
                  "
                  :disabled="dirtyOptions[i] === 'N/A'"
                />
                <div
                  :class="$style.removeInput"
                  v-if="i !== dirtyOptions.length && dirtyOptions[i] !== 'N/A'"
                  @click="dirtyOptions = dirtyOptions.filter((_, j) => j !== i)"
                >
                  <b-icon icon="close" size="is-small"></b-icon>
                </div>
              </div>
            </div>
          </b-field>
        </div>
      </div>
    </draggable>
  </b-field>
</template>

<script lang="ts">
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { CheckboxesCriterionContent } from '@/store/types/criterions.types';
import { isTruthy } from '@/jbi-shared/util/watcher.vue-decorator';
import { isEqual as _isEqual } from 'lodash';
import draggable from 'vuedraggable';

@Component({
  components: { ValidationProvider, ValidationObserver, draggable },
})
export default class CheckboxesCriterionInput extends Vue {
  @Prop({
    default() {
      return ['N/A'];
    },
  })
  public options!: CheckboxesCriterionContent['checkboxesOptions'];

  public dirtyOptions!: CheckboxesCriterionContent['checkboxesOptions'];
  public drag = false;

  public data(): {
    dirtyOptions: CheckboxesCriterionContent['checkboxesOptions'];
  } {
    return {
      dirtyOptions: [...(this.options ?? ['N/A'])],
    };
  }

  @Watch('dirtyOptions')
  public onChanged() {
    this.$emit('update:options', [...this.dirtyOptions]);
  }

  @isTruthy
  @Watch('options')
  public onRangeUpdated() {
    const next = [...(this.options ?? ['N/A'])];
    if (!_isEqual(this.dirtyOptions, next)) {
      this.dirtyOptions = next;
    }
  }
}
</script>

<style lang="scss" module>
.container {
  &#{&} {
    margin-bottom: 0;
  }

  :global .field {
    margin-bottom: 6px;
  }
}

.inputContainer {
  display: flex;
  align-items: center;

  .dotContainer {
    margin-right: 8px;
    cursor: move;

    .dot {
      width: 12px;
      height: 12px;
      border: 1px solid $grey-border-2;
    }
  }

  :global(.control) {
    flex: 1 1 100%;
    position: relative;

    input {
      padding-right: 30px;
    }

    .removeInput {
      visibility: hidden;
      display: flex;
      cursor: pointer;
      position: absolute;
      align-items: center;
      height: 100%;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      font-size: 16px;
      padding: 0 10px;
      color: $grey-border-2;
    }

    &:hover .removeInput {
      visibility: visible;
    }
  }

  + :global(.help) {
    margin-left: 20px;
  }
}
</style>
